import { FeatureValue  } from "./FeatureValue";

export class ClassificationFeature {

  constructor(
    public description?: string,
    public name?: string,
    public order: number = 1,
    public valueType: string = "List",
    public unit?: string,
    public isRequired: boolean = false,
    public values?: FeatureValue[]
  ) {
  }
}
